/**
 * `/reports/*` — the canonical, single reports experience. Wraps
 * `BackendReportScope` once (previously mounted twice: independently by
 * `ReportsApp`'s hash router and by the embedded `BackendReportsWorkspace`,
 * both retired by this migration) and renders the matched report page
 * through `<Outlet>`.
 *
 * @module router/reports/ReportsLayout
 */

import React from "react";

import { Outlet } from "react-router";

import { ReportScopeNotice } from "@/components/reports/ReportScopeNotice";
import { LinkTabs, PageHeader } from "@/components/ui";
import { BackendReportScope } from "@/reports/ReportTenantScope";

/** The reports, in the order the tab strip lists them. */
export const REPORT_TABS = [
  { to: "/reports/library", label: "Programme Library", "data-testid": "reports-tab-library" },
  { to: "/reports/dashboard", label: "Dashboard", "data-testid": "reports-tab-dashboard" },
  { to: "/reports/disciplines", label: "Disciplines", "data-testid": "reports-tab-disciplines" },
  { to: "/reports/compare", label: "Compare", "data-testid": "reports-tab-compare" },
  { to: "/reports/analysis", label: "Analysis", "data-testid": "reports-tab-analysis" },
  { to: "/reports/validation", label: "Validation", "data-testid": "reports-tab-validation" },
  { to: "/reports/modules", label: "Module Catalogue", "data-testid": "reports-tab-modules" },
] as const;

export function ReportsLayout(): React.ReactElement {
  return (
    <BackendReportScope>
      <div className="space-y-6" data-testid="reports-workspace">
        <PageHeader title="Reports" description={<ReportScopeNotice />} />
        <LinkTabs items={REPORT_TABS} aria-label="Reports" />
        <Outlet />
      </div>
    </BackendReportScope>
  );
}
